import { colorSet } from '@components/Provider';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      flexDirection: 'column',
      [theme.breakpoints.down('xs')]: {
        paddingTop: '16px'
      },
      '&>:not(:last-child)': {
        marginBottom: 20
      },
      '& .thumbnail': {
        width: 52,
        height: 52,
        border: `1px solid ${colorSet.gray200}`,
        borderRadius: 8,
        '&.avatar': {
          borderRadius: '50%',
          border: 'none'
        }
      },
      '& .no-review': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 422
      }
    },
    comment: {
      display: 'flex',
      alignItems: 'flex-start',
      padding: '4px 0px'
    },
    avatar: {
      width: 32,
      height: 32,
      marginRight: 10,
      '& img': {
        width: 32,
        height: 32,
        borderRadius: '50%',
        border: 'none'
      }
    },
    item: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      width: '100%'
    },
    company: {
      marginBottom: 8
    },
    rating: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: 2,
      '& .stars': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: 88
      },
      '& .createdAt': {
        marginLeft: 8
      }
    },
    contents: {
      display: 'flex',
      width: '100%',
      justifyContent: 'space-between',
      '& .breakAll': {
        width: '100%',
        whiteSpace: 'pre-line',
        wordBreak: 'break-all',
        maxHeight: 72,

        '&.elipsis': {
          overflowY: 'hidden',
          lineClamp: 3,
          display: '-webkit-box',
          '-webkit-box-orient': 'vertical'
        },

        [theme.breakpoints.down('xs')]: {
          marginRight: 0
        },

        '&.more': {
          maxHeight: '100%',
          width: '100%',
          lineClamp: 'none',
          display: 'inherit',
          '-webkit-box-orient': 'none'
        }
      },
      '& .inner__contents': {
        display: 'flex',
        flexDirection: 'column',
        width: 'calc(100% - 112px)',
        [theme.breakpoints.down('xs')]: { width: '100%', marginBottom: 12 },
        '&.inner__contents-more': {
          width: 'calc(100%)'
        },
        '&.inner__contents-no_img': {
          width: 'calc(100%)'
        }
      }
    },
    images: {
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%',
      '& > div': {
        width: 'calc(100% / 2 - 1px) !important'
      }
    },
    image: {
      position: 'relative',

      '&.image-preview': {
        width: 96,
        height: 96,
        [theme.breakpoints.down('xs')]: {
          width: '100%',
          height: 160
        },
        '&.cursor': {
          cursor: 'pointer'
        }
      },

      '&.image-gutterBottom': {
        marginBottom: 8
      },

      '&.image-gutterTop': {
        marginTop: 16,
        [theme.breakpoints.down('xs')]: {
          marginTop: 0
        }
      },

      '&.image-more': {
        maxWidth: 544,
        maxHeight: 624,
        width: '100%',
        height: '100%',
        [theme.breakpoints.down('xs')]: {
          height: '100%',
          width: '100%'
        }
      },

      '& img': {
        width: '100%',
        height: '100%',
        borderRadius: 8,

        '&.more': { objectFit: 'contain', height: '100%', maxHeight: 624 },
        [theme.breakpoints.down('xs')]: {
          width: '100%',
          height: 160,
          '&.left__radius': {
            borderRadius: '8px 0px 0px 8px',
            objectFit: 'cover'
          },
          '&.right__radius': {
            borderRadius: '0px 8px 8px 0px',
            objectFit: 'cover'
          }
        }
      },
      '& .bottom__count': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'absolute',
        bottom: 0,
        right: 0,
        backgroundColor: `rgba(0,0,0,0.6)`,
        width: 23,
        height: 23,
        borderRadius: '8px 0px 8px 0px',
        '& span': {
          ...theme.typography.caption,
          fontWeight: 'normal',
          color: colorSet.gray000
        }
      },
      '& .right__overlay': {
        cursor: 'pointer',
        zIndex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'absolute',
        bottom: 0,
        right: 0,
        backgroundColor: `rgba(0,0,0,0.32)`,
        width: '100%',
        height: '100%',
        borderRadius: '0px 8px 8px 0px',
        '& span': {
          ...theme.typography.body1,
          fontWeight: '500',
          color: colorSet.gray000
        }
      }
    },
    more: {
      display: 'flex',
      alignItems: 'center',
      marginTop: 4,
      cursor: 'pointer',
      '& svg': {
        marginLeft: 4,
        transform: 'scaleY(1)',
        '&.animation': {
          transform: 'scaleY(-1)'
        }
      }
    },
    menu: {
      top: 0,
      right: 0,
      position: 'absolute',
      width: 32,
      height: 32,
      padding: 6
    },
    popover: {
      transition: 'background-color 0.2s ease-in-out',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      width: 188,
      padding: 16,
      borderRadius: 8,
      boxShadow:
        '0px 5px 5px -3px rgba(0, 0, 0, 0.1), 0px 8px 10px 1px rgba(0, 0, 0, 0.07), 0px 3px 14px 2px rgba(0, 0, 0, 0.06)',
      '& svg': {
        marginRight: 12
      },
      '& span': {
        ...theme.typography.body2,
        fontWeight: 500
      },
      '&:hover': {
        backgroundColor: colorSet.backgroundLight
      }
    },
    visibie: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginTop: 24,
      '& button': {
        minWidth: '87px !important'
      }
    }
  }),
  { classNamePrefix: 'review__list-wirtten' }
);

export default useStyles;
